import { EMortgageOffersTabs } from '../../../enums/EMortgageOffersTabs';

interface ITab {
  value: EMortgageOffersTabs;
}

export function getInitialTab(tabs: ITab[]): number | null {
  return tabs.length > 0 ? 0 : null;
}
